import FetchBase from '../Api/FetchBase'
import { observable, action, computed } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'

export default class EquipmentsStore extends FetchBase {
  @observable equipmentsLoader = false
  @observable equipmentDeleteLoader = false
  @observable equipmentModalLoader = false

  @observable equipments = []
  @observable totalEquipments = 0
  @observable currentEquipmentPage = DEFAULT_PAGE_START

  @observable equipmentsSearchText = ''

  @action.bound
  setEquipmentsSearchText = (value = '') => {
    this.equipmentsSearchText = value
  }

  @action.bound
  setCurrentEquipmentPage = (value = DEFAULT_PAGE_START) => {
    this.currentEquipmentPage = value
  }

  @action.bound
  getEquipmentsFilters = () => {
    let temp = {}
    this.equipmentsSearchText && (temp['search'] = this.equipmentsSearchText)
    return temp
  }

  @computed
  get resultEquipmentList() {
    return this.equipments
  }

  @action.bound
  getAllEquipmentsExport = async (spaceId, { exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getEquipmentsFilters()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_EQUIPMENT, {
        spaceId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getAllEquipments = async (spaceId) => {
    try {
      this.equipmentsLoader = true
      let options = this.getEquipmentsFilters() || {}
      let response = await this.get(API_ENDPOINTS.GET_EQUIPMENTS, {
        spaceId,
        ...options,
      })
      if (response.status) {
        this.equipments = response.data
        this.totalEquipments = response.data.length || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.equipmentsLoader = false
    }
  }

  @action.bound
  getSpecificEquipment = (id) => {
    return (this.equipments || []).find((equipment) => equipment.id === id)
  }

  @action.bound
  addEquipment = async (spaceId, values) => {
    try {
      this.equipmentModalLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_EQUIPMENT, {
        spaceId,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.equipmentModalLoader = false
    }
  }

  @action.bound
  updateEquipmentLocally = (id, value) => {
    this.equipments = (this.equipments || []).map((equipment) =>
      equipment.id === id ? value : equipment
    )
  }

  @action.bound
  updateEquipmentModal = async (id) => {
    try {
      this.equipmentModalLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_EQUIPMENT, {
        ...id,
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.equipmentModalLoader = false
    }
  }

  @action.bound
  updateEquipment = async (id, values) => {
    try {
      this.equipmentModalLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_EQUIPMENT, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.equipmentModalLoader = false
    }
  }

  @action.bound
  deleteEquipment = async (id) => {
    try {
      this.equipmentDeleteLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_EQUIPMENT, {
        id,
      })
      return [response.status, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.equipmentDeleteLoader = false
    }
  }

  @action.bound
  resetStore = () => {
    this.equipmentsLoader = false
    this.equipmentDeleteLoader = false
    this.equipmentModalLoader = false
    this.equipments = []
    this.totalEquipments = 0
    this.currentEquipmentPage = DEFAULT_PAGE_START
    this.equipmentsSearchText = ''
  }
}
